export default __webpack_public_path__ + "static/media/profile_place_holder.4ce775c1.svg";